// extracted by mini-css-extract-plugin
export var container = "_cn-0";
export var content = "_cn-3";
export var customerTitle = "_cn-4";
export var empty = "_cn-5";
export var gray = "_cn-6";
export var header = "_cn-7";
export var info = "_cn-8";
export var loading = "_cn-2";
export var loadingCard = "_cn-9";
export var oneLine = "_cn-a";
export var personName = "_cn-e";
export var pillContainer = "_cn-b";
export var selected = "_cn-1";
export var text = "_cn-c";
export var twoLines = "_cn-d";
export var unread = "_cn-f";
export var unreadIndicator = "_cn-g";